"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GEOLOCATION = {
    NOT_SUPPORTED: 'not_supported',
};
